import { render, staticRenderFns } from "./InternalChat.vue?vue&type=template&id=933f2100"
import script from "./InternalChat.vue?vue&type=script&lang=js"
export * from "./InternalChat.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports